// src/Components/SEO/SEO.jsx
import React from "react";
import { Helmet } from "react-helmet-async";

const SEO = ({ title, description, keywords, url, organization }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />

      {/* Twitter */}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:card" content="summary_large_image" />

      {/* Structured data */}
      <script type="application/ld+json">
        {JSON.stringify(
          organization || {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "IDLBAY Private Limited",
            alternateName: "IDLBAY",
            url: "https://idlbay.com",
            logo: "https://idlbay.com/idlbaylogo.png",
            sameAs: [
              "https://www.linkedin.com/company/idlbay/",
              "https://x.com/idlbayPvtLtd",
              "https://www.instagram.com/idlbay.official?igsh=dnIxMm50cmdxNDNy",
              "https://www.facebook.com/profile.php?id=61582746578911",
              "https://www.youtube.com/channel/UCDSb9__-mSLqeyuZYelakcw",
            ],
            contactPoint: {
              "@type": "ContactPoint",
              telephone: "+91-9840841840",
              contactType: "Customer Support",
              areaServed: "IN",
              availableLanguage: ["English", "Tamil"],
            },
            address: {
              "@type": "PostalAddress",
              streetAddress:
                "Office No.1, First Floor, Door No.1, B Narasimhan 3rd Street",
              addressLocality: "T-Nagar, Chennai",
              addressRegion: "Tamil Nadu",
              postalCode: "600017",
              addressCountry: "IN",
            },
          }
        )}
      </script>
    </Helmet>
  );
};

export default SEO;
